const {text} = window;
const {highContrast, dyslexic} = window.OverDrive;
export default () => `
    <div>${text('gdpr.settingsPanel.summary')}</div>
    <div class="optionContainer">
        <i class="icon-check"></i>
        <h3 class="requiredHeading">${text('gdpr.settingsPanel.requiredHeading')}</h3>
        <span class="labelSubtext requiredSubtext">${text('gdpr.settingsPanel.requiredBody')}</span>
    </div>
    <div class="optionContainer">
        <span class="perfCookieCheckbox"></span>
        <span class="labelSubtext">${text('gdpr.settingsPanel.performanceBody')}</span>
    </div>
    <div class="optionContainer">
        <span class="analyticsCookieCheckbox"></span>
        <span class="labelSubtext">${text('gdpr.settingsPanel.analyticsBody')}</span>
    </div>
    <div class="divider"></div>
    <div class="addendum">
        ${text('gdpr.settingsPanel.addendum', {
            cookiePolicyLink: `<a target="blank" href="https://company.cdn.overdrive.com/policies/cookie-policy.htm?${highContrast ? 'high-contrast=1' : ''}${dyslexic ? 'dyslexic=1' : ''}">${text('gdpr.cookiePolicy')}</a>`,
            privacyPolicyLink: `<a target="blank" href="https://company.cdn.overdrive.com/policies/privacy-policy.htm?${highContrast ? 'high-contrast=1' : ''}${dyslexic ? 'dyslexic=1' : ''}">${text('footerPrivacyPolicy')}</a>`
        })}
    </div>


    <button class="confirm button radius margin-small secondary right">${text('gdpr.settingsPanel.confirm')}</button>

`;
